import { render, staticRenderFns } from "./WasteExchangeMainConfirmView.vue?vue&type=template&id=6e4552f0&scoped=true"
import script from "./WasteExchangeMainConfirmView.vue?vue&type=script&lang=js"
export * from "./WasteExchangeMainConfirmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4552f0",
  null
  
)

export default component.exports